import { Controller } from '@hotwired/stimulus'
import { debounce } from '../utils/debounce'

// Updates selection info via Turbo when selection changes.
// Listens to selection:change events and fetches updated info from server.
// Supports "select all matching" mode for bulk operations on all query results.
export default class extends Controller {
  static values = {
    url: String,
    query: String,
  }

  #selectAll = false
  #currentIds = []

  connect() {
    this.fetchInfo = debounce(this.#fetchInfo.bind(this), 150)
  }

  selectionChanged(event) {
    const ids = event.detail?.ids || []
    this.#currentIds = ids

    // Clear select_all mode when selection changes
    if (this.#selectAll) {
      this.#selectAll = false
      this.#dispatchSelectAllChange()
    }

    this.fetchInfo(ids)
  }

  selectAllMatching(event) {
    event.preventDefault()
    this.#selectAll = true
    this.#dispatchSelectAllChange()
    this.fetchInfo(this.#currentIds)
  }

  clearSelectAll(event) {
    event.preventDefault()
    this.#selectAll = false
    this.#dispatchSelectAllChange()
    window.dispatchEvent(new CustomEvent('selection:reset'))
  }

  #fetchInfo(ids) {
    const url = new URL(this.urlValue, window.location.origin)

    if (this.queryValue) {
      url.searchParams.set('q', this.queryValue)
    }

    if (this.#selectAll) {
      url.searchParams.set('select_all', 'true')
    }

    ids.forEach((id) => {
      url.searchParams.append('block_ids[]', id)
    })

    fetch(url, {
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then((response) => response.text())
      .then((html) => {
        this.element.innerHTML = html
      })
  }

  #dispatchSelectAllChange() {
    window.dispatchEvent(
      new CustomEvent('selection:select-all-change', {
        detail: { selectAll: this.#selectAll },
      }),
    )
  }
}
